import { render, staticRenderFns } from "./UsageTotal.vue?vue&type=template&id=67491cc8&"
import script from "./UsageTotal.vue?vue&type=script&lang=js&"
export * from "./UsageTotal.vue?vue&type=script&lang=js&"
import style0 from "./UsageTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports